import { memo } from 'react';
import styles from './TransportBar.module.css';

/**
 * Waveform overview (F3.10): one mirrored bar per stored peak, stretched to the overview's width.
 * SVG in currentColor, so it follows the theme and needs no redraw on resize.
 */
export const Waveform = memo(function Waveform({ peaks }: { peaks: number[] }) {
  const d = peaks
    .map((p, i) => {
      const h = Math.max(0.04, p) * 0.5;
      return `M${i} ${0.5 - h}h0.7v${2 * h}h-0.7z`;
    })
    .join('');
  return (
    <svg
      className={styles.waveform}
      viewBox={`0 0 ${peaks.length} 1`}
      preserveAspectRatio="none"
      aria-hidden="true"
      focusable="false"
    >
      <path d={d} fill="currentColor" />
    </svg>
  );
});
